import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'keyValueTranslate',
  pure: false,
})
export class KeyValueTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value, prefix: string) {
    const result = {};
    Object.keys(value).forEach(key => {
      const transKey = `${prefix}.${value[key]}`;
      const translated = this.translate.instant(transKey);
      result[key] = transKey === translated ? value[key] : translated;
    });

    return result;
  }

}
